import type { FC } from 'react';
import React from 'react';

import type { TDefaultIcon } from './models';

export const DefaultIcon: FC<TDefaultIcon> = ({ Img, ShieldIcon, iconSettings }) =>
    iconSettings ? (
        <Img alt={iconSettings.alt} height={32} src={iconSettings.src} width={32} />
    ) : (
        <ShieldIcon color={'#B6BCC3'} height={32} width={32} />
    );
